export default "__VITE_ASSET__95d99bc9__"